import React from 'react';
import { Spend } from './Spend';
import { Saving } from './Saving';

interface ContentProps {
	percentage?: number;
	months?: number;
}

export function Content({ percentage = 0, months = 0 }: Readonly<ContentProps>) {
	return percentage > 0 ? <Saving months={months} percentage={percentage} /> : <Spend />;
}
